import { ReportMedia } from "@shared/lib/types/reports";
import { Button } from "@shared/ui";
import { Error } from "@shared/ui/icons";
import styles from "./styles.module.scss";

type NonTrackableCardProps = {
  nonTrackableLinks: ReportMedia[];
  onViewLinks: () => void;
};

export function NonTrackableCard({
  nonTrackableLinks,
  onViewLinks,
}: NonTrackableCardProps) {
  const count = nonTrackableLinks.length;
  if (count === 0) return null;

  return (
    <div className={styles.card}>
      <div className={styles.cardContent}>
        <div className={styles.cardIcon}>
          <Error className={styles.cardIconColor} />
        </div>
        <div className={styles.cardBody}>
          <h4 className={styles.cardTitle}>
            {count} content link{count > 1 ? "s" : ""} not added to reports
          </h4>
          <p className={styles.cardDescription}>
            These links are non-trackable. We can only track valid post links on
            Instagram and YouTube.
          </p>
        </div>
      </div>
      <Button
        type="default"
        onClick={onViewLinks}
        className={styles.viewLinksButton}
      >
        View Links
      </Button>
    </div>
  );
}
